import AddRouteLabel from "./AddRouteLabel";
import AnnounceSet from "./AnnounceSet";
import { ChangeCompetitorCategory } from "./ChangeCompetitorCategory";
import ConfirmDeleteChallenge from "./ConfirmDeleteChallenge";
import ConfirmDeleteCompetition from "./ConfirmDeleteCompetition";
import ConfirmDeleteCompetitor from "./ConfirmDeleteCompetitor";
import ConfirmDeleteLeague from "./ConfirmDeleteLeague";
import ConfirmDeleteQuest from "./ConfirmDeleteQuest";
import ConfirmDeleteTaskSet from "./ConfirmDeleteTaskSet";
import ConfirmDeleteVenueColor from "./ConfirmDeleteVenueColor";
import ConfirmPublishCompetitionResults from "./ConfirmPublishCompetitionResults";
import ConfirmRestoreStrippedRoute from "./ConfirmRestoreStrippedRoute";
import ConfirmStripRoute from "./ConfirmStripRoute";
import ConfirmUncompleteSettingTask from "./ConfirmUncompleteSettingTask";
import { CreateTask } from "./CreateTask";
import EditZone from "./EditZone";
import GenericModal from "./GenericModal";
import MergeLeagueEntries from "./MergeLeagueEntries";
import { MoveRoutes } from "./MoveRoutes";
import PostConfirmCompetitionRoutes from "./PostConfirmCompetitionResults";
import PrintRoutes from "./PrintRoutes";
import RestoreArchiveRoutes from "./RestoreArchiveRoutes";
import { StripRoutes } from "./StripRoutes";
import TargetsSettingsModal from "./TargetsSettingsModal";
import TaskValidationFailed from "./TaskValidationFailed";
import UnsavedCategoryChanges from "./UnsavedCompetitionCategoryChanges";
import UnsavedRouteChanges from "./UnsavedRouteChanges";

export const MODAL_REGISTRY = {
  MOVE_ROUTES: MoveRoutes,
  PRINT_ROUTES: PrintRoutes,
  STRIP_ROUTES: StripRoutes,
  UNSAVED_ROUTE_CHANGES_PROMPT: UnsavedRouteChanges,
  UNSAVED_COMPETITION_CATEGORY_CHANGES_PROMPT: UnsavedCategoryChanges,
  CREATE_TASK: CreateTask,
  ANNOUNCE_SET: AnnounceSet,
  TASK_VALIDATION_FAILED: TaskValidationFailed,
  CONFIRM_UNCOMPLETE_SETTING_TASK: ConfirmUncompleteSettingTask,
  CONFIRM_RESTORE_STRIPPED_ROUTE: ConfirmRestoreStrippedRoute,
  CONFIRM_STRIP_ROUTE: ConfirmStripRoute,
  CONFIRM_DELETE_TASKSET: ConfirmDeleteTaskSet,
  CONFIRM_DELETE_CHALLENGE: ConfirmDeleteChallenge,
  CONFIRM_DELETE_COMPETITION: ConfirmDeleteCompetition,
  CONFIRM_DELETE_LEAGUE: ConfirmDeleteLeague,
  CONFIRM_DELETE_QUEST: ConfirmDeleteQuest,
  CONFIRM_DELETE_COMPETITOR: ConfirmDeleteCompetitor,
  CONFIRM_DELETE_VENUE_COLOR: ConfirmDeleteVenueColor,
  CONFIRM_PUBLISH_COMPETITION_RESULTS: ConfirmPublishCompetitionResults,
  POST_CONFIRM_COMPETITION_RESULTS: PostConfirmCompetitionRoutes,
  CHANGE_COMPETITOR_CATEGORY: ChangeCompetitorCategory,
  GENERIC_MODAL: GenericModal,
  EDIT_ZONE: EditZone,
  ADD_ROUTE_LABEL: AddRouteLabel,
  RESTORE_ARCHIVE_ROUTES: RestoreArchiveRoutes,
  MERGE_LEAGUE_ENTRIES: MergeLeagueEntries,
  TARGETS_SETTINGS: TargetsSettingsModal,
};
